<template>
  <div class="passenger-flow-statistics">
    <div class="app-panel search-panel blank-h">
      <div class="app-control app-table-control">
        <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="search.periodOne" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" clearable></el-date-picker>
        <el-select v-model="search.project" placeholder="请选择项目" multiple collapse-tags>
          <el-option v-for="(value, index) in projectOptions" :key="index" :label="value.project_attr_name" :value="value.project_id"></el-option>
        </el-select>
        <el-button type="primary" @click="searchParams">搜索</el-button>
        <el-button @click="resetParams">重置</el-button>
      </div>
    </div>
    <div class="app-panel blank-v blank-h panel-1">
      <p class="app-title mb">客流指标</p>
      <div class="wrap">
        <div class="item">
          <p>{{panelOneValueOne}}</p>
          <p>客流总量</p>
        </div>
        <div class="item">
          <p>{{panelOneValueTwo}}</p>
          <p>到访客户总人数</p>
        </div>
        <div class="item">
          <p>{{panelOneValueThree}}</p>
          <p>首访客户人数</p>
        </div>
        <div class="item">
          <p>{{panelOneValueFour}}</p>
          <p>复访客户人数</p>
        </div>
        <div class="item">
          <p>{{panelOneValueFive}}</p>
          <p>识别集团员工人数</p>
        </div>
        <div class="item">
          <p>{{panelOneValueSix}}</p>
          <p>识别外部员工人数</p>
        </div>
      </div>
    </div>
    <div class="app-panel blank-v blank-h panel-2">
      <p class="app-title mb">客群画像</p>
      <ve-bar :data="chartOne.datas" :colors="chartOne.colors"></ve-bar>
    </div>
    <div class="app-panel blank-v blank-h panel-3">
      <p class="app-title mb">新老客户比例</p>
      <ve-ring :data="chartTwo.datas" :colors="chartTwo.colors" :legend="chartTwo.legend"></ve-ring>
    </div>
    <div class="app-panel blank-v blank-h panel-4">
      <p class="app-title mb">近30天客流趋势</p>
      <ve-line :data="chartThree.datas" :colors="chartThree.colors"></ve-line>
    </div>
  </div>
</template>

<script>
  import ProjectService from '@/io/project.js';
  import StatisticsService from '@/io/statistics.js';

  export default {
    name: 'PassengerFlowStatistics',
    data() {
      return {
        search: {
          periodOne: null,
          project: '',
        },
        projectOptions: [],
        pickerOptions: {
          shortcuts: [
            {
              text: '昨日',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                picker.$emit('pick', [start, start]);
              }
            },
            {
              text: '近3日',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '近7日',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '近14日',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '近30日',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        },
        panelOneValueOne: 0,
        panelOneValueTwo: 0,
        panelOneValueThree: 0,
        panelOneValueFour: 0,
        panelOneValueFive: 0,
        panelOneValueSix: 0,
        chartOne: {
          datas: {
            columns: [],
            rows: []
          },
          colors: ['#108AF9', '#F2637B'],
        },
        chartTwo: {
          datas: {
            columns: [],
            rows: []
          },
          colors: ['#FED973', '#7FC3FF'],
          legend: {
            orient: 'vertical',
            x: 'right'
          }
        },
        chartThree: {
          datas: {
            columns: [],
            rows: []
          },
          colors: ['#FED973', '#7FC3FF'],
        },
      }
    },
    mounted () {
      this.initOptions().then(() => {
        this.initDatas();
      }).catch(() => {});
    },
    methods: {
      initOptions() {
        return ProjectService.project().then(res => {
          this.projectOptions = res.data;
        }).catch(() => {});
      },
      initDatas() {
        StatisticsService.flow(
          this.search.periodOne ? this.search.periodOne[0] : '',
          this.search.periodOne ? this.search.periodOne[1] : '',
          this.search.project
        ).then(res => {
          this.panelOneValueOne = res[0].data.customer_visit_volume;
          this.panelOneValueTwo = res[1].data.customer_volume;
          this.panelOneValueThree = res[2].data.first_visit_customer_volume;
          this.panelOneValueFour = res[3].data.visited_customer_volume;
          this.panelOneValueFive = res[4].data.staff_volume;
          this.panelOneValueSix = res[5].data.external_staff_volume;
          this.chartOne.datas = {
            columns: ['指标', '男', '女'],
            rows: [
              {
                '指标': '1-15岁',
                '男': res[6].data[0].man,
                '女': res[6].data[0].women
              },
              {
                '指标': '16-30岁',
                '男': res[6].data[1].man,
                '女': res[6].data[1].women
              },
              {
                '指标': '31-45岁',
                '男': res[6].data[2].man,
                '女': res[6].data[2].women
              },
              {
                '指标': '46-60岁',
                '男': res[6].data[3].man,
                '女': res[6].data[3].women
              },
              {
                '指标': '60岁以上',
                '男': res[6].data[4].man,
                '女': res[6].data[4].women
              },
            ]
          }
          this.chartTwo.datas = {
            columns: ['指标', '数量'],
            rows: [
              {
                '指标': '新顾客',
                '数量': res[7].data.customer_first_visit,
              },
              {
                '指标': '老顾客',
                '数量': res[7].data.customer_visited,
              }
            ]
          }
        }).catch(() => {});
        StatisticsService.monthFlowTrend(
          this.search.project
        ).then(res => {
          this.chartThree.datas = {
            columns: ['指标', '新顾客', '老顾客'],
            rows: res.data.result_arr.map((value, index) => {
              return {
                '指标': res.data.days_arr[index],
                '新顾客': value.first_visit_volume,
                '老顾客': value.visited_volume
              }
            })
          };
        }).catch(() => {});
      },
      searchParams() {
        this.initDatas();
      },
      resetParams() {
        this.search.periodOne = null;
        this.searchParams();
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .passenger-flow-statistics {
    margin: -10px;
    .app-panel {
      box-shadow: 0px 0px 20px 0px rgba(102, 126, 164, 0.05);
      float: left;
      margin: 10px;
      &.search-panel {
        width: calc(100% - 60px);
        /deep/ .app-table-control {
          .el-select {
            input {
              width: 350px;
            }
          }
        }
      }
      &.panel-1 {
        width: calc(100% - 60px);
        .wrap {
          display: flex;
          text-align: center;
          .item {
            flex: 1;
            p {
              &:nth-of-type(1) {
                font-size: 40px;
                margin-bottom: 10px;
                color: @color-primary;
              }
              &:nth-of-type(2) {
                color: @color-text-3;
              }
            }
          }
        }
      }
      &.panel-2,
      &.panel-3 {
        width: calc(100%/2 - 60px);
      }
      &.panel-4 {
        width: calc(100% - 60px);
      }
    }
  }
</style>